declare namespace $ {

	type $mol_button_copy__sub_shm_hitalama_map_widget_float_code_bench_result_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_copy['sub'] >
	>
	type $mol_button_copy__text_shm_hitalama_map_widget_float_code_bench_result_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['copy_text'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_code_bench_result_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['error_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__code_sidebar_showed_shm_hitalama_map_widget_float_code_bench_result_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_text['code_sidebar_showed'] >
	>
	type $mol_dump_value__expanded_shm_hitalama_map_widget_float_code_bench_result_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['expanded'] >
		,
		ReturnType< $mol_dump_value['expanded'] >
	>
	type $mol_dump_value__minimal_height_shm_hitalama_map_widget_float_code_bench_result_6 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_dump_value['minimal_height'] >
	>
	type $mol_dump_value__value_shm_hitalama_map_widget_float_code_bench_result_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['state'] >
		,
		ReturnType< $mol_dump_value['value'] >
	>
	type $mol_grid__minimal_height_shm_hitalama_map_widget_float_code_bench_result_8 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_grid['minimal_height'] >
	>
	type $mol_grid__records_shm_hitalama_map_widget_float_code_bench_result_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['result_table_rows'] >
		,
		ReturnType< $mol_grid['records'] >
	>
	type $mol_grid__col_ids_shm_hitalama_map_widget_float_code_bench_result_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['result_table_col_ids'] >
		,
		ReturnType< $mol_grid['col_ids'] >
	>
	type $mol_grid__col_head_content_shm_hitalama_map_widget_float_code_bench_result_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['col_head_content'] >
		,
		ReturnType< $mol_grid['col_head_content'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_float_code_bench_result_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['result_view'] >
		,
		ReturnType< $mol_scroll['sub'] >
	>
	export class $shm_hitalama_map_widget_float_code_bench_result extends $mol_view {
		Copy_icon( ): $mol_icon_content_copy
		copy_text( ): string
		Copy( ): $mol_button_copy
		error_text( ): string
		Error( ): $mol_text
		expanded( next?: boolean ): boolean
		state( ): any
		Result( ): $mol_dump_value
		result_table_rows( ): Record<string, any>
		result_table_col_ids( ): readonly(any)[]
		col_head_content( id: any): readonly(any)[]
		Result_table( ): $mol_grid
		result_view( ): readonly(any)[]
		Result_row( ): $mol_scroll
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=result.view.tree.d.ts.map